import React from 'react';
import { Car } from 'lucide-react';

interface AddVehicleCardProps {
  onAdd: () => void;
}

const AddVehicleCard: React.FC<AddVehicleCardProps> = ({ onAdd }) => {
  return (
    <div
      onClick={onAdd}
      className="flex flex-col items-center justify-center bg-[#add015] rounded-xl shadow-md border-2 border-dashed border-[#8bc34a] cursor-pointer hover:bg-[#b8e35a] transition-colors h-[600px] p-6"
      style={{ color: '#111111' }}
    >
      <span className="text-6xl font-extrabold mb-4" style={{ color: '#111111' }}>+</span>
      <Car className="w-24 h-24 mb-4" style={{ color: '#111111' }} />
      <span className="text-2xl font-bold" style={{ color: '#111111' }}>Neues Fahrzeug</span>
    </div>
  );
};

export default AddVehicleCard; 